export default "__VITE_PUBLIC_ASSET__4323d3bc__"